import { Component, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from '../qms.service';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-search-users',
  templateUrl: './search-users.component.html',
  styleUrls: ['./search-users.component.scss']
})

export class SearchUsersComponent {

  @Output() valueEmitter = new EventEmitter<string>();

  isProcessing = false;
  searchCriteriaOptions: any = ['All Quality Users', 'Group Users'];
  selectedUserCriteria: any;

  popupTitle: string = '';
  designationSearchText: string = '';
  departmentSearchText: string = '';
  groupUserSearchText: string = '';
  selectedGroupUserName: string = '';
  selectionMode: string = '';

  listOfUsers: any = [];
  dropdownGroupUsers: any = [];
  groupUsersDropdown: any = [];
  designationDropdown: any = [];
  departmentDropdown: any = [];
  dropDownForDesignation: any = [];
  dropDownForDepartment: any = [];
  tempMultiUsersArray: any = [];
  multiUsersArray: any = [];

  draftUser: any = {};

  selectedGroupUser: any = null;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByEmail: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;

  isSwitchingUser: boolean = false;
  changeInCriteria: boolean = false;
  searchUserParentCheckBox: boolean = false;

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, public switchUserComponent: SwitchuserComponent,
    public paginationService: PaginationService, public message: messageService, public qmsService: qmsService) {
  }

  public trigger(): void {
    const currentUrl = this.router.url;
    console.log(currentUrl);
    this.changeInCriteria = currentUrl == '/dashboard/locationMasterComponent' || currentUrl == '/dashboard/instrument-master';

    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.selectBoxForDepartment();
    this.selectBoxForDesignation();
    this.reset();
    this.selectedUserCriteria = 'All Quality Users';
    this.visibleSearchUserPopup = this.dialog.open(this.searchUserPopup, this.searchUserPopupConfig);
  }

  public get isAddDisabled(): boolean {
    if (this.selectionMode === 'single') {
      return this.draftUser && Object.keys(this.draftUser).length === 0;
    } else {
      return this.tempMultiUsersArray.length === 0;
    }
  }

  @ViewChild('searchUserPopup', { static: true }) searchUserPopup: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('reasonPopup', { static: true }) reasonPopup: TemplateRef<any>;
  visibleReasonPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmationPopup', { static: true }) confirmationPopup: TemplateRef<any>;
  visibleConfirmationPopup: MatDialogRef<TemplateRef<any>>;

  searchUserPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  reasonPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };

  confirmationPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };

  public onParentCheckBoxChanged(e: any): void {
    if (e.target.checked) {
      this.tempMultiUsersArray = [];
      this.onParentChecked();
    } else {
      this.searchUserParentCheckBox = false;
      this.onParentUnChecked();
    }
  }

  public onParentChecked(): void {
    for (const user of this.listOfUsers) {
      user.searchUserChildCheckBox = true;
      this.tempMultiUsersArray.push({ userId: user.userId, userName: user.userName });
    }
  }

  public onParentUnChecked(): void {
    this.listOfUsers.every((user: any) => {
      user.searchUserChildCheckBox = false; return true;
    })
    this.tempMultiUsersArray = [];
  }

  public onChildCheckBoxChanged(e: any, childData: any, idx: any): void {
    if (e.target.checked) {
      childData.searchUserChildCheckBox = true;
      this.onChildChecked(childData);
    } else {
      childData.searchUserChildCheckBox = this.searchUserParentCheckBox = false;
      this.onChildUnchecked(childData);
    }
  }

  public onChildChecked(checkedUser: any): void {
    if (!this.multiUsersArray?.some((user: any) => user.userId === checkedUser.userId)) {
      this.tempMultiUsersArray.push({ userId: checkedUser.userId, userName: checkedUser.userName })
    }

    if (this.listOfUsers?.every((user: any) => user.searchUserChildCheckBox)) this.searchUserParentCheckBox = true;
  }

  public onChildUnchecked(uncheckedUser: any): void {
    const removal = this.tempMultiUsersArray?.findIndex((removableUser: any) => removableUser.userId == uncheckedUser.userId);
    if (removal > -1) this.tempMultiUsersArray?.splice(removal, 1);
  }

  public onChecked(e: any, data: any): void {
    this.listOfUsers.every((item: any) => { if (item.searchUserChildCheckBox) { item.searchUserChildCheckBox = false; } return true; })

    if (e.target.checked) {
      data.searchUserChildCheckBox = true;
      this.draftUser = data;
    } else {
      data.searchUserChildCheckBox = false;
      this.draftUser = {};
    }
  }

  public onSearchCriteriaChanged(criteria: any): void {

    this.reset();

    if (criteria == 'Group Users') {
      this.isProcessing = true;
      this.appService.getQmsActiveUsersByGroupIdModule(this.qmsService.selectedActivityGroupId, this.qmsService.moduleName).subscribe(((groupUsers: any) => {
        this.dropdownGroupUsers = groupUsers.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
        this.selectBoxForGroupUsers();
        this.isProcessing = false;
      }))
    }
  }

  private selectBoxForGroupUsers(): void {
    this.groupUsersDropdown = this.dropdownGroupUsers?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  public onGroupUserSelect(event: any, user: any): void {
    if (event.isUserInput) {
      this.selectedGroupUserName = user.displayExp;
    }
  }

  public onMultiGroupUserSelect(event: any, user: any): void {
    if (event.isUserInput) {
      if (user)
        console.log(user);
    }
  }

  @ViewChild('multi') multi: MatSelect;
  isAllUserSelected = false;
  public toggleAllSelection(value: any): void {
    if (value == 'multi') {
      if (this.isAllUserSelected) this.multi.options.forEach((item: MatOption) => item.select());
      else this.multi.options.forEach((item: MatOption) => item.deselect())
    }
  }

  private selectBoxForDepartment(): void {
    this.departmentDropdown = this.dropDownForDepartment?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp?.trim()?.localeCompare(n.displayExp?.trim())) || []
  }

  private selectBoxForDesignation(): void {
    this.designationDropdown = this.dropDownForDesignation?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp?.trim()?.localeCompare(n.displayExp?.trim())) || []
  }

  public isDisabled(): boolean {
    if (this.selectedUserCriteria === 'All Quality Users')
      return this.selectionMode == 'single' ? this.draftUser && Object.keys(this.draftUser).length === 0 : !this.tempMultiUsersArray.length;
    else
      return this.selectionMode == 'single' ? !this.selectedGroupUser : !this.tempMultiUsersArray.length;
  }

  public reset(): void {
    [
      this.searchByUserName,
      this.searchByFirstName,
      this.searchByLastName,
      this.searchByEmail,
      this.selectedGroupUserName,
      this.searchByDesignationCode,
      this.searchByDepartmentCode,
      this.selectedGroupUser,
      this.listOfUsers,
      this.tempMultiUsersArray,
      this.multiUsersArray
    ] = ['', '', '', '', '', null, null, null, [], [], []];
  }

  public focusSearch(value: any): void {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus(); }, 0)
  }

  public cancelSearchUserPopup(): void {
    this.visibleSearchUserPopup.close();
  }

  public searchUser(): void {

    let searchByUserName;
    if (this.selectedUserCriteria == 'All Quality Users') {
      this.isProcessing = true;
      if (this.searchByUserName) {
        searchByUserName = this.searchByUserName.toUpperCase();
      } else {
        this.searchByUserName = '';
      }

      const data = {
        userName: searchByUserName,
        firstName: this.searchByFirstName,
        lastName: this.searchByLastName,
        emailAddress: this.searchByEmail,
        designationCode: this.searchByDesignationCode,
        departmentCode: this.searchByDepartmentCode,
        module: "QMS" /* Note: module is mandatory in java query. Values can be assigned to module are 'QMS', 'TRN', 'DOCS'... and so on */
      };

      this.appService.getUsersDetailsFromOneQmsUsersWithRoles(data).subscribe((response: any) => {
        this.listOfUsers = response.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
        this.isProcessing = false;
      })
    } else if (this.selectionMode == 'single') {
      this.qmsService.selectedSearchUserId = this.selectedGroupUser;
      this.qmsService.selectedSearchUserName = this.selectedGroupUserName;

      if (this.isSwitchingUser) {
        if (this.message.switchUserCurrentValue == this.selectedGroupUser) {
          this.showSnackBar("Sorry, can't switch to the same user", 'E');
          return;
        } else {
          this.message.switchedUser = this.draftUser.userId;
          this.switchUserComponent.reasonForSwitch = '';
          this.visibleSearchUserPopup.close();
          this.visibleReasonPopup = this.dialog.open(this.reasonPopup, this.reasonPopupConfig);
        }
      } else {
        this.visibleSearchUserPopup.close();
        this.triggerEmit();
      }
    } else {
      this.multiUsersArray = this.groupUsersDropdown?.filter((x: any) => this.tempMultiUsersArray.includes(x.valueExp)).map((user: any) => ({ userId: user.valueExp, userName: user.displayExp }));
      this.visibleSearchUserPopup.close();
      this.triggerEmit();
    }
  }

  selectUser() {
    if (this.selectionMode == 'single') {
      this.qmsService.selectedSearchUserId = this.draftUser.userId;
      this.qmsService.selectedSearchUserName = this.draftUser.userName;

      if (this.isSwitchingUser) {
        if (this.message.switchUserCurrentValue == this.draftUser.userId) {
          this.showSnackBar("Sorry, can't switch to the same user", 'E');
          return;
        } else {
          this.message.switchedUser = this.draftUser.userId;
          this.switchUserComponent.reasonForSwitch = '';
          this.visibleSearchUserPopup.close();
          this.visibleReasonPopup = this.dialog.open(this.reasonPopup, this.reasonPopupConfig);
        }
      } else {
        this.visibleSearchUserPopup.close();
        this.triggerEmit();
      }
    } else {
      this.multiUsersArray = this.tempMultiUsersArray;
      this.visibleSearchUserPopup.close();
      this.triggerEmit();
    }
  }

  triggerEmit() {
    if (this.isSwitchingUser) {
      this.createSwitchUserLog();
      this.visibleReasonPopup.close();
      this.visibleConfirmationPopup.close();
      this.valueEmitter.emit();
    } else {
      this.valueEmitter.emit();
    }
  }

  createSwitchUserLog() {
    this.isProcessing = true;
    let data = {
      switchUserLogId: null,
      module: this.qmsService.moduleName ?? 'FL',
      refNo: this.message.activityId,
      version: this.message.version,
      groupId: this.qmsService.selectedGroupDetailData.groupId,
      subModuleName: this.message.submodule,
      subModuleRefNo: this.message.subModuleId,
      userRole: 'Assign To',
      fromUser: this.message.switchUserCurrentValue,
      toUser: this.qmsService.selectedSearchUserId,
      reasonForSwitch: this.switchUserComponent.reasonForSwitch,
      status: this.qmsService.activity.status,
      deleteReason: null
    }

    this.appService.createOneQmsSwitchUserLog(data).subscribe({
      next: (Response: any) => {
        this.isProcessing = false;
        this.showSnackBar(Response.result, Response.resultType);
      },
      error: (error) => { throw error; }
    });

  }

  mandatoryValidation(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '' : 'red';
  }

  closeReasonPopup() {
    this.visibleReasonPopup.close();
  }

  openConfirmationPopup() {
    if (this.switchUserComponent.reasonForSwitch) {
      this.visibleConfirmationPopup = this.dialog.open(this.confirmationPopup, this.confirmationPopupConfig);
    } else {
      this.showSnackBar('Please enter the Reason', 'E');
    }
  }

  closeConfirmationPopup() {
    this.visibleConfirmationPopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe({
      next: () => {
        sb.dismiss();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      },
      complete: () => { }
    })
  }

}
